var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33547 2.96704C7.08231 2.52195 7.97716 2.25 9 2.25C11.7542 2.25 14.0642 4.22187 14.5632 7.36085C15.2796 7.4679 16.0349 7.73901 16.6586 8.21594C17.4394 8.81305 18 9.72615 18 10.9688C18 12.16 17.5598 13.0879 16.8058 13.713C16.5666 13.9112 16.212 13.8781 16.0137 13.6389C15.8155 13.3997 15.8486 13.0451 16.0878 12.8469C16.5586 12.4566 16.875 11.8595 16.875 10.9688C16.875 10.1083 16.5039 9.5139 15.9752 9.10959C15.4283 8.6914 14.7003 8.47149 14.0332 8.43674C13.7556 8.42228 13.5302 8.2072 13.5028 7.93057C13.2157 5.03911 11.2469 3.375 9 3.375C8.18347 3.375 7.48714 3.59032 6.9114 3.93343C6.64454 4.09247 6.29928 4.00506 6.14024 3.7382C5.9812 3.47134 6.06861 3.12608 6.33547 2.96704ZM3.11635 5.90895C3.31434 5.8427 3.53273 5.89156 3.68361 6.03586L11.6518 13.656C11.8179 13.8148 11.8706 14.0587 11.7851 14.2719C11.6995 14.4852 11.4928 14.625 11.263 14.625H4.78125C2.20256 14.625 0 12.8058 0 10.125C0 7.91015 1.3755 6.49147 3.11635 5.90895ZM3.16156 7.09324C1.95801 7.60005 1.125 8.60753 1.125 10.125C1.125 12.0848 2.71931 13.5 4.78125 13.5H9.86095L3.16156 7.09324Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85225 1.85225C2.07192 1.63258 2.42808 1.63258 2.64775 1.85225L16.1477 15.3523C16.3674 15.5719 16.3674 15.9281 16.1477 16.1477C15.9281 16.3674 15.5719 16.3674 15.3523 16.1477L1.85225 2.64775C1.63258 2.42808 1.63258 2.07192 1.85225 1.85225Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud);
export default __webpack_public_path__ + "static/media/icon-cloud.21d80f77bbeab2c13212f42f533893f0.svg";
export { ForwardRef as ReactComponent };